var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoney(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5129 12.7V16.12H1.47289L0.932891 14.04C1.54622 13.56 2.00622 13.0467 2.31289 12.5C2.63289 11.9533 2.82622 11.2933 2.89289 10.52H0.832891V7.58H2.37289C2.14622 6.62 2.03289 5.77333 2.03289 5.04C2.03289 4.10667 2.24622 3.30667 2.67289 2.64C3.11289 1.97333 3.71289 1.46667 4.47289 1.12C5.24622 0.76 6.13289 0.579999 7.13289 0.579999C8.78622 0.579999 10.0662 1.02 10.9729 1.9C11.8796 2.78 12.3796 3.94 12.4729 5.38H8.39289C8.29956 4.58 7.93289 4.18 7.29289 4.18C6.59956 4.18 6.25289 4.64 6.25289 5.56C6.25289 5.78667 6.29956 6.08667 6.39289 6.46C6.48622 6.82 6.58622 7.19333 6.69289 7.58H10.0529V10.52H7.05289C6.85289 11.4667 6.43956 12.1933 5.81289 12.7H12.5129Z",
    fill: "#499FD7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.cd411bff.svg";
export { ForwardRef as ReactComponent };